;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.OffSeasonBase = Marionette.ItemView.extend({
		club_name: '',
		template: JST.clubOffSeason,
		winner: false,
		hide_winners: false,

		ui: {
			name: '#user_name',
			email: '#email',
			submit_btn: '#login-submit',
			form: '#js-pre-pregister-form',
			message: '.js-thanks-message'
		},

		events: {
			'click @ui.submit_btn': 'preregister',
			'submit @ui.form': 'preregister'
		},

		initialize: function() {
			console.log("config offseason view", CONFIG);
			this.model.set({
				club_name: this.club_name,
				season: CONFIG.SEASON,
				last_season: CONFIG.SEASON - 1,
				winner: this.winner,
				hide_winners: this.hide_winners,
			});

			this.initListeners();
		},

		initListeners: function() {
			this.listenTo(this.model, 'preregistration:success', this.changeBtnState);
			this.listenTo(this.model, 'preregistration:errors', this.showErrors);
		},

		preregister: function() {
			var name = this.ui.name.val(),
				email = this.ui.email.val();

			if (!name || !email) {
				return this;
			}

			this.model.preregistration({
				email:      email,
				first_name: name
			});
		},

		changeBtnState: function() {
			this.ui.form.hide();

			this.ui.message.removeClass('hidden');
		}
	});

}(window, APP, Backbone, Marionette, $, _));